import {
  Flex,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useMediaQuery,
} from "@chakra-ui/react";
import CenterHeader from "@components/CenterHeader";

import useExchangeRate from "@hooks/useExchangeRate";
import useTVL from "hooks/useTVL";

import { useState } from "react";

import { useRestakeApy } from "@hooks/useRestakeApy";
import StakeComponent from "../../components/Stake/Stake";
// import Image from "next/image";
import SanctionBanner from "@components/SanctionBanner";
import UnstakeComponent from "@components/Unstake/Unstake";
import Withdraw from "@components/Withdraw";
import useSanction from "@hooks/useSanction";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
// import { BANNER_IMAGES } from "@constants/banner";
// import { Carousel } from "react-responsive-carousel";
// import BaseImage from "@components/BaseImage";

const Stake = () => {
  const tvl = useTVL();
  const apyData = useRestakeApy();
  const conversionData = useExchangeRate();
  const [tabIndex, setTabIndex] = useState(0);
  const [isLargerThan768] = useMediaQuery("(min-width: 768px)");

  const heading =
    tabIndex === 0 ? "Restake" : tabIndex === 1 ? "Unstake" : "Withdraw";

  const { isSanctioned } = useSanction();

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      p={{ base: "0 16px", md: 0 }}
    >
      {isSanctioned && (
        <Flex
          flexDir="column"
          gap="12px"
          mt={{ base: "16px", xl: "0px" }}
          w={{ base: "100%", md: "648px" }}
          mb="12px"
        >
          {<SanctionBanner />}
        </Flex>
      )}

      <Flex
        flexDir="column"
        gap="16px"
        mt={{ base: "16px", xl: "0px" }}
        w={"100%"}
        align={"center"}
        pointerEvents={isSanctioned ? "none" : "auto"}
        opacity={isSanctioned ? 0.5 : 1}
      >
        {/* <Flex
          overflow="hidden"
          w={{ base: "100%", md: "648px" }}
          borderRadius="24px"
          position="relative"
        >
          <Carousel
            autoPlay={true}
            infiniteLoop={true}
            interval={4000}
            showArrows={true}
            showIndicators={true}
            showThumbs={false}
            stopOnHover={false}
            showStatus={false}
          >
            {BANNER_IMAGES.map((image) => (
              <BaseImage
                key={image}
                src={image}
                alt="image banner"
                width={1620}
                height={600}
                layout="responsive"
              />
            ))}
          </Carousel>
        </Flex> */}

        {/* <RestakeBanner /> */}
        <Flex
          borderRadius="24px"
          bg="backgroundCard"
          p={{ base: "0 16px 24px", md: "40px" }}
          flexDir="column"
          gap={{ base: "24px", md: "40px" }}
          w={{ base: "100%", md: "648px" }}
        >
          <CenterHeader tvl={tvl} restakeApy={apyData} heading={heading} />

          <Tabs
            p="0"
            onChange={(index) => {
              setTabIndex(index);
            }}
            index={tabIndex}
            isFitted={isLargerThan768 ? false : true}
          >
            <TabList fontWeight="600" lineHeight="24px">
              <Tab fontSize={{ base: "14px", md: "16px" }}>Stake</Tab>
              <Tab fontSize={{ base: "14px", md: "16px" }}>Unstake</Tab>
              <Tab fontSize={{ base: "14px", md: "16px" }}>Withdraw</Tab>
            </TabList>

            <TabPanels mt={{ base: "24px", md: "40px" }}>
              <TabPanel p="0">
                <StakeComponent
                  conversionData={conversionData}
                  isActive={tabIndex === 0}
                />
              </TabPanel>
              <TabPanel p="0" h="inherit">
                <UnstakeComponent
                  conversionData={conversionData}
                  isActive={tabIndex === 1}
                />
              </TabPanel>
              <TabPanel p="0" h="inherit">
                <Withdraw />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Stake;
